var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"pedido-processo-intro",attrs:{"text":"","color":"primary","icon":_vm.icon}},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.titulo))]),_c('div',{staticClass:"text-body-2 mt-1"},[_vm._v(_vm._s(_vm.descricao))])])
}
var staticRenderFns = []

export { render, staticRenderFns }